import { FC, ReactNode } from 'react'
import { usePermissions } from 'react-admin'

interface RestrictedButtonProps {
  access: string[]
  children: ReactNode
}

const RestrictedButton: FC<RestrictedButtonProps> = ({ access, children }) => {
  const { permissions } = usePermissions<{ scopes: string[] }>()
  if (!permissions?.scopes?.length) return null
  if (!access.some((scope) => permissions.scopes.includes(scope))) return null
  return <>{children}</>
}

export default RestrictedButton
